module.exports = __webpack_public_path__ + "img/practiceR1Completion.434c08d.gif";